@if (content) {
  <div>
    <p class="p1 m-t"
    *iCms="'message' of content; skipEmpty: true"></p>
  </div>
}
